import { Popup, popupBoilerplate } from './Popup';

import PopupCheatsAB from './PopupCheatsAB';

import PopupError from './PopupError';
import PopupNetworkError from './PopupNetworkError';
import PopupReplicationError from './PopupReplicationError';
import PopupSessionDesyncError from './PopupSessionDesyncError';
import PopupVersionError from './PopupVersionError';
import PopupInfo from './PopupInfo';
import PopupFaq from './PopupFaq';
import PopupModalWhite from './PopupModalWhite';

import PopupConversationScript from '../conversation/PopupConversationScript';
import PopupSelectionalScript from '../conversation/PopupSelectionalScript';
import PopupDescriptiveScript from '../conversation/PopupDescriptiveScript';
import PopupPetNameInput from '../conversation/PopupPetNameInput';
import PopupSelectCareItem from '../../popups/PopupSelectCareItem';
import PopupConfirmCareItem from '../../popups/PopupConfirmCareItem';

import PopupTermsPolicyDetails from '../termsPolicy/details/PopupTermsPolicyDetails';
import PopupTermsPolicy from '../termsPolicy/PopupTermsPolicy';

import PopupConfirmation from './PopupConfirmation';
import PopupMaintenance from './PopupMaintenance';

import PopupSpeechBubble from '../conversation/PopupSpeechBubble';
import PopupTutorialStep from '../../popups/PopupTutorialStep';
import PopupTutorialReward from '../../popups/PopupTutorialReward';
import PopupFeatureDisabled from '../../popups/PopupFeatureDisabled';
import PopupAcceptToS from '../../popups/PopupAcceptToS';
import PopupInviteReward from '../../popups/PopupInviteReward';
import PopupInviteFriends from '../../popups/PopupInviteFriends';
import PopupConfirmInvite from '../../popups/PopupConfirmInvite';
import PopupConfirmInviteMulti from '../../popups/PopupConfirmInviteMulti';

// Shop
import PopupCoinsShop from '../../shop/PopupCoinsShop';
import PopupCoinsExchanged from '../../shop/PopupCoinsExchanged';
import PopupEnergyShop from '../../shop/PopupEnergyShop';
import PopupEnergyExchanged from '../../shop/PopupEnergyExchanged';
import PopupGemsShop from '../../shop/PopupGemsShop';
import PopupPurchaseComplete from '../../shop/PopupPurchaseComplete';

// Admin reimburse message
import PopupAdminReimburse from '../../popups/PopupAdminReimburse';

// Profile
import PopupEditProfile from 'src/game/popups/PopupEditProfile';
import PopupAvatarSelection from 'src/game/popups/PopupAvatarSelection';
import PopupProfile from 'src/game/popups/PopupProfile';
import PopupSettings from './PopupSettings';

// Minigames
import PopupSelectMinigame from '../../popups/PopupSelectMinigame';
import PopupMinigameResults from 'src/game/popups/PopupMinigameResults';

// Gifts
import PopupGiftsList from '../../gifts/PopupGiftsList';
import PopupGiftReward from 'src/game/gifts/PopupGiftReward';
import PopupGiftsConfirmation from 'src/game/gifts/PopupGiftsConfirmation';
import PopupGiftsConfirmationMulti from 'src/game/gifts/PopupGiftsConfirmationMulti';

// Level
import PopupLevelUPReward from 'src/game/level/popups/PopupLevelUPReward';

// Encyclopedia
import PopupEncyclopedia from 'src/game/encyclopedia/PopupEncyclopedia';

// Visit
import PopupVisitFriend from '../../visit/popups/PopupVisitFriend';
import PopupConfirmVisitFriend from '../../visit/popups/PopupConfirmVisitFriend';
import PopupVisitReward from 'src/game/visit/popups/PopupVisitReward';

// Native
import PopupInstallAppIos from '../../native/popups/PopupInstallAppIos';
import PopupInstallAppAndroid from '../../native/popups/PopupInstallAppAndroid';
import PopupLoginCrossplay from '../../native/popups/PopupLoginCrossplay';
import PopupNativeLineGuestLogin from '../../native/popups/PopupNativeLineGuestLogin';
import PopupInstallNativeApp from '../../native/popups/PopupInstallNativeApp';
import PopupInstallNativeReward from '../../native/popups/PopupInstallNativeReward';

// Duo
import PopupDuoResponse from 'src/game/duo/popup/PopupDuoResponse';
import PopupDuoInvitations from 'src/game/duo/popup/PopupDuoInvitations';
import PopupDuoResponseSuccess from 'src/game/duo/popup/PoupDuoResponseSuccess';
import PopupDuoReminderConfirmation from 'src/game/duo/popup/PopupDuoReminderConfirmation';
import PopupDuoReminderSuccess from 'src/game/duo/popup/PoupDuoReminderSuccess';
import PopupDuoReward from 'src/game/duo/popup/PopupDuoReward';
import PopupShareInvite from 'src/game/popups/PopupShareInvite';

//
// Registry.

export const popupRegistry = {
  // Term / Privacy popups
  popupTermsPolicy: popupBoilerplate(PopupTermsPolicy),
  popupTermsPolicyDetails: popupBoilerplate(PopupTermsPolicyDetails),

  // Conversation
  popupConversationScript: popupBoilerplate(PopupConversationScript),
  popupSelectionalScript: popupBoilerplate(PopupSelectionalScript),
  popupDescriptiveScript: popupBoilerplate(PopupDescriptiveScript),
  popupSpeechBubble: popupBoilerplate(PopupSpeechBubble),
  popupPetNameInput: popupBoilerplate(PopupPetNameInput),

  // Care popups
  popupSelectCareItem: popupBoilerplate(PopupSelectCareItem),
  popupConfirmCareItem: popupBoilerplate(PopupConfirmCareItem),

  // Social popups
  popupInviteFriends: popupBoilerplate(PopupInviteFriends),
  popupConfirmInvite: popupBoilerplate(PopupConfirmInvite),
  popupConfirmInviteMulti: popupBoilerplate(PopupConfirmInviteMulti),
  popupInviteReward: popupBoilerplate(PopupInviteReward),
  popupShareInvite: popupBoilerplate(PopupShareInvite),

  // Tutorial popups
  popupAcceptToS: popupBoilerplate(PopupAcceptToS),
  popupTutorialStep: popupBoilerplate(PopupTutorialStep),
  popupTutorialReward: popupBoilerplate(PopupTutorialReward),

  // Settings popups
  popupSettings: popupBoilerplate(PopupSettings),
  popupFaq: popupBoilerplate(PopupFaq),

  // Error popups
  popupError: popupBoilerplate(PopupError),
  popupNetworkError: popupBoilerplate(PopupNetworkError),
  popupReplicationError: popupBoilerplate(PopupReplicationError),
  popupSessionDesyncError: popupBoilerplate(PopupSessionDesyncError),
  popupVersionError: popupBoilerplate(PopupVersionError),

  // Generic popups
  popupInfo: popupBoilerplate(PopupInfo),
  popupConfirmation: popupBoilerplate(PopupConfirmation),
  popupMaintenance: popupBoilerplate(PopupMaintenance),
  popupFeatureDisabled: popupBoilerplate(PopupFeatureDisabled),
  popupModalWhite: popupBoilerplate(PopupModalWhite),

  // Shop
  popupCoinsShop: popupBoilerplate(PopupCoinsShop),
  popupCoinsExchanged: popupBoilerplate(PopupCoinsExchanged),
  popupEnergyShop: popupBoilerplate(PopupEnergyShop),
  popupEnergyExchanged: popupBoilerplate(PopupEnergyExchanged),
  popupGemsShop: popupBoilerplate(PopupGemsShop),
  popupPurchaseComplete: popupBoilerplate(PopupPurchaseComplete),

  // Admin reimburse message
  popupAdminReimburse: popupBoilerplate(PopupAdminReimburse),

  // Profile
  popupProfile: popupBoilerplate(PopupProfile),
  popupEditProfile: popupBoilerplate(PopupEditProfile),
  popupAvatarSelection: popupBoilerplate(PopupAvatarSelection),

  // Minigames
  popupSelectMinigame: popupBoilerplate(PopupSelectMinigame),
  popupMinigameResults: popupBoilerplate(PopupMinigameResults),

  // Gifts
  popupGiftsList: popupBoilerplate(PopupGiftsList),
  popupGiftReward: popupBoilerplate(PopupGiftReward),
  popupGiftsConfirmation: popupBoilerplate(PopupGiftsConfirmation),
  popupGiftsConfirmationMulti: popupBoilerplate(PopupGiftsConfirmationMulti),

  // Level
  popupLevelUPReward: popupBoilerplate(PopupLevelUPReward),

  // Visit
  popupVisitReward: popupBoilerplate(PopupVisitReward),
  popupVisitFriend: popupBoilerplate(PopupVisitFriend),
  popupConfirmVisitFriend: popupBoilerplate(PopupConfirmVisitFriend),

  // Encyclopedia
  popupEncyclopedia: popupBoilerplate(PopupEncyclopedia),

  // Native
  popupInstallAppIos: popupBoilerplate(PopupInstallAppIos),
  popupInstallAppAndroid: popupBoilerplate(PopupInstallAppAndroid),
  popupLoginCrossplay: popupBoilerplate(PopupLoginCrossplay),
  popupNativeLineGuestLogin: popupBoilerplate(PopupNativeLineGuestLogin),
  popupInstallNativeApp: popupBoilerplate(PopupInstallNativeApp),
  popupInstallNativeReward: popupBoilerplate(PopupInstallNativeReward),

  // Duo
  popupDuoResponse: popupBoilerplate(PopupDuoResponse),
  popupDuoResponseSuccess: popupBoilerplate(PopupDuoResponseSuccess),
  popupDuoInvitations: popupBoilerplate(PopupDuoInvitations),
  popupDuoReminderConfirmation: popupBoilerplate(PopupDuoReminderConfirmation),
  popupDuoReminderSuccess: popupBoilerplate(PopupDuoReminderSuccess),
  popupDuoReward: popupBoilerplate(PopupDuoReward),

  // Cheat popups
  ...(process.env.IS_DEVELOPMENT
    ? {
        popupCheats: null as Popup, // Fill in popup manager.
        popupTestPopups: null as Popup, // Fill in popup manager.
        popupCheatsAB: popupBoilerplate(PopupCheatsAB), // Fill in popup manager.
      }
    : null),
};

//
// Types.

type PopupRegistry = typeof popupRegistry;
export type PopupID = keyof PopupRegistry;
export type PopupOpenArgs<
  TPopupID extends PopupID
> = PopupRegistry[TPopupID] extends Popup<infer OA, any> ? OA : never;
export type PopupCloseArgs<
  TPopupID extends PopupID
> = PopupRegistry[TPopupID] extends Popup<any, infer CA> ? CA : never;

export type PopupIdByArgs<TOpenArgs extends {}> = {
  [K in PopupID]: TOpenArgs extends PopupOpenArgs<K> ? K : never;
}[PopupID];

//
// Helpers.

export function isPopupId(id: string): id is PopupID {
  return id in popupRegistry;
}
